<ds-status-badge [object]="object"></ds-status-badge>
@if (isMyDSpaceStatus) {
  <ds-my-dspace-status-badge [context]="context"></ds-my-dspace-status-badge>
}
<div>
  <ds-type-badge class="pe-1" [object]="object"></ds-type-badge>
  @if (showAccessStatus) {
    <ds-access-status-badge [object]="object"></ds-access-status-badge>
  }
</div>
